module.exports = __webpack_public_path__ + "static/street-logo-updated-8b182e167863fde3b0f48fec3ec8d6dc.png";